module.exports = __webpack_public_path__ + "img/prize-points.791da5b1.png";